<template>
    <div
        v-bind:class="{ 'calendar-button': true, 'active': openMenu }"
        v-on:click="handleClick"
    >
        <div class="calendar-button__icon">
            <icon-calendar />
        </div>
    </div>
</template>

<script>
import IconCalendar from '@img/icons/tonscan/calendar.svg?vue';

export default {
    props: ['toggleMenu', 'openMenu'],
    methods: {
        handleClick() {
            this.toggleMenu();
        },
    },
    components: {
        IconCalendar,
    },
};
</script>

<style lang="scss">
.calendar-button {
    display: flex;
    align-items: center;
    gap: 10px;
    position: relative;
    border-radius: 8px;
    //border: 2px solid var(--card-row-separator);
    padding: 0 8px;
    line-height: 36px;
    user-select: none;
    z-index: 90;
    svg {
        width: 100%;
        height: 100%;
    }
    &__icon {
        display: flex;
        align-items: center;
        width: 18px;
        color: var(--body-muted-text-color);
        fill: var(--blue-bright);
        height: 36px;
        z-index: 1;
    }
    &__title {
        text-transform: uppercase;
        font-weight: 500;
        color: var(--card-header-tab-color);
    }
}
.calendar-button.active {
    border-color: var(--blue-bright);
}
.active {
    .calendar-button {
        &__icon {
            color: var(--body-text-color);
        }
        &__title {
            color: var(--body-text-color);
        }
    }
}
@media screen and (max-width: 480px) {
    .calendar-button, .calendar-button.active {
        border-color: transparent;
        padding: 0 5px;
    }
}
</style>
